<template>
  <v-dialog
    :value="value"
    @input="emitClose"
    persistent
    max-width="1600"
  >
    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer />
        <v-btn icon :disabled="!accepted" @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <div class="scroll-box">
          
          <div v-if="!contentType" class="d-flex align-center justify-center py-12">
            <v-progress-circular indeterminate color="primary" class="me-3" />
          </div>

          <!-- HTML -->
          <div v-if="contentType==='html'" v-html="htmlContent"></div>

          <!-- PDF -->
          <embed
            v-if="contentType==='pdf'"
            :src="fileUrl"
            type="application/pdf"
            style="width:100%; height:68vh;"
          />

          <!-- IMAGEN -->
          <img
            v-if="contentType==='image'"
            :src="fileUrl"
            style="max-width:100%;"
          />

          <!-- VIDEO -->
          <video
            v-if="contentType==='video'"
            :src="fileUrl"
            controls
            style="width:100%;"
          />

        </div>
      </v-card-text>

      <v-card-actions class="justify-end">
        <v-checkbox
          v-model="accepted"
          :label="t('IHaveReadTheDocument')"
        />
        <v-btn
          class="ml-6"
          color="primary"
          :disabled="!accepted"
          @click="close"
        >
          {{ t("Accept") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { ref, watch, onMounted } from "vue";
import documentManagementDocument from "lib-document-management-vue/src/lib-components/documents/documentManagementDocument.js";
import documentManagement from "lib-document-management-vue/src/lib-components/documentManagement.js"

import { i18n } from "@/plugins/i18n";

export default {
  props: {
    value: Boolean,
    documentId: String,
    userDocId: String,
    title: String,
  },

  setup(props, { emit }) {
    const { LibDocumentManagementRs, t } = documentManagementDocument();
    const { getFileStream } = documentManagement();

    const accepted = ref(false);
    const documentData = ref(null);

    const contentType = ref(null);
    const htmlContent = ref("");
    const fileUrl = ref("");

    function emitClose(v) {
      emit("input", v);
    }

    function close() {
      emit("accepted", { id: props.userDocId });
      emit("input", false);
    }

    function resolveLang(doc) {
      const appLang = i18n.locale;
      const langs = doc.titles?.map(t => t.locale) || [];

      const hasEN = langs.includes("en-GB");
      const hasES = langs.includes("es-ES");

      if (appLang === "es-ES" && hasES) return "es-ES";
      if (appLang === "en-GB" && hasEN) return "en-GB";

      return hasEN ? "en-GB" : langs[0];
    }

    async function loadDocument() {
      try {
        const res = await LibDocumentManagementRs.methods.getDocumentData(
          props.documentId,
          false
        );
        documentData.value = res.data;

        const lang = resolveLang(documentData.value);

        const stream = await getFileStream(
          props.documentId,
          documentData.value.objectId.version,
          lang,
          null,
          "document",
          false,
          false
        );

        if (!stream) return;

        if (stream.type === "text/html") {
          contentType.value = "html";
          htmlContent.value = await stream.text();
          return;
        }

        const blob = await stream.blob?.() || stream;
        const url = URL.createObjectURL(blob);
        fileUrl.value = url;

        if (stream.type === "application/pdf") contentType.value = "pdf";
        else if (stream.type.startsWith("image/")) contentType.value = "image";
        else if (stream.type === "video/mp4") contentType.value = "video";

      } catch (e) {
        console.error("QuickGuide ERROR:", e);
      }
    }

    onMounted(loadDocument);
    watch(() => props.documentId, loadDocument);

    return {
      accepted,
      contentType,
      htmlContent,
      fileUrl,
      close,
      emitClose,
      t,
    };
  },
};
</script>

<style scoped>
.scroll-box {
  height: 70vh;
  overflow-y: auto;
  border: 1px solid rgba(0,0,0,0.12);
  border-radius: 8px;
  padding: 0 12px;
}
</style>